import { decryptPlugin, DECRYPT_SIGN } from './decrypt-plugin'
const CLASS_NAME = 'virtual-grid__inner__table__row__cell__'

const { DECRYPT_checkMaskInRow } = decryptPlugin()
export function decryptCellClass (params) {
  const { row, column } = params
  if (!row) {
    return []
  }
  const { key } = column
  const isMask = DECRYPT_checkMaskInRow(row, key)
  const decrypt_key = DECRYPT_SIGN + key
  const classes = []
  if (row[decrypt_key] && key === decrypt_key.replace(DECRYPT_SIGN, '')) {
    classes.push(`${CLASS_NAME}color-8b60f0`)
  }
  if (isMask) {
    row[decrypt_key] = true
    classes.push(`${CLASS_NAME}decrypt`)
  }
  return classes
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/table2/feature/cell-decrypt/decrypt-cell-class.js